import { NgModule } from '@angular/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { PageFooterComponent } from './page-footer/page-footer.component';
import { SearchComponent } from './search-component/search-component.component';

@NgModule({

    imports: [        
        ReactiveFormsModule,
        CommonModule,
        NgbModule
    ],
    declarations: [      
        PageFooterComponent,
        SearchComponent
    ],
    exports: [        
        PageFooterComponent,
        SearchComponent
    ]
})
export class ComponentPageModule{}



